module.exports = __webpack_public_path__ + "static/assets/24f3713255b28e81843bb2c8836f14d9.png";